import {applyMiddleware, combineReducers, createStore} from 'redux';
import thunkMiddleware from 'redux-thunk';
import {createLogger} from 'redux-logger';
import {jwtMiddleware} from '../modules/jwt-middleware';
import {authentication} from "../modules/authentication/auth.reducer";
import {users} from "../modules/users/users.reducer";
import {patrimoines} from "../modules/patrimoines/patrimoines.reducer";
import {problems} from "../modules/problems/problems.reducer";
import {forms} from "../modules/forms/forms.reducer";
import {laveuses} from "../modules/laveuses/laveuses.reducer";
import {campaigns} from "../modules/campaigns/campaigns.reducer";
import {interventions} from "../modules/interventions/interventions.reducer";
import {conteneurs} from "../modules/conteneurs/conteneurs.reducer";
import {dashboard} from "../modules/dashboard/dashboard.reducer";
import {prestations} from "../modules/prestations/prestations.reducer";
import {agences} from "../modules/agences/agences.reducer";
import {rhdata} from "../modules/rhdata/rhdata.reducer.js";
import {heures} from "../modules/heures/heures.reducer.js";
import {quartix} from "../modules/quartix/quartix.reducer.js";
import {tourneesGraffiti} from "../modules/tourneesGraffiti/tourneesGraffiti.reducer";
import {graffiti} from "../modules/graffiti/graffiti.reducer";
import {geo} from "../modules/geo/geo.reducer";
import {anomalies} from "../modules/anomalies/anomalies.reducer.js";
import { graffitiApi } from '../modules/graffiti/graffiti.api';
import { reportingTourneesApi } from '../modules/reportingTournees/reportingTournees.api';
import { conteneurMapApi } from '../modules/conteneurMap/conteneurMap.api';
import { clientsApi } from '../modules/users/clients.api';
import { campaignsApi } from '../modules/campaigns/campaigns.api';
import { patrimoinesApi } from '../modules/patrimoines/patrimoines.api';
import conteneurMapReducer from '../modules/conteneurMap/conteneurMap.slice';
import { consignesApi } from '../modules/consignes/consignes.api';
import { modesOperatoiresApi } from '../modules/modesOperatoires/modesOperatoires.api';
import { actesApi } from '../modules/actes/actes.api';
import { conteneurConsignesApi } from '../modules/conteneurConsignes/conteneurConsignes.api';
import { formActesApi } from '../modules/formActes/formActes.api';
import { exportsApi } from '../modules/exports/exports.api';
import { interventionDetailApi } from '../modules/interventions/interventionDetail.api';
import { pilotageApi } from '../pilotage/api';
import { simulationsApi } from '../modules/simulations/simulations.api';
import { setupListeners } from '@reduxjs/toolkit/query';

const middlewares = [jwtMiddleware, thunkMiddleware, graffitiApi.middleware, conteneurMapApi.middleware, clientsApi.middleware, campaignsApi.middleware, patrimoinesApi.middleware, reportingTourneesApi.middleware, consignesApi.middleware, modesOperatoiresApi.middleware, actesApi.middleware, conteneurConsignesApi.middleware, formActesApi.middleware, exportsApi.middleware, interventionDetailApi.middleware, pilotageApi.middleware, simulationsApi.middleware];

// Include redux-logger only in development to avoid runtime overhead in production
if (import.meta && import.meta.env && import.meta.env.DEV) {
  const loggerMiddleware = createLogger();
  middlewares.push(loggerMiddleware);
}

const store = createStore(
    combineReducers({
        authentication,
        users,
        patrimoines,
        problems,
        forms,
        laveuses,
        campaigns,
        interventions,
        conteneurs,
        dashboard,
        prestations,
        agences,
        rhdata,
        heures,
        quartix,
        tourneesGraffiti,
        graffiti,
        geo,
        anomalies,
        [graffitiApi.reducerPath]: graffitiApi.reducer,
        [conteneurMapApi.reducerPath]: conteneurMapApi.reducer,
        [clientsApi.reducerPath]: clientsApi.reducer,
        [campaignsApi.reducerPath]: campaignsApi.reducer,
        [patrimoinesApi.reducerPath]: patrimoinesApi.reducer,
        [reportingTourneesApi.reducerPath]: reportingTourneesApi.reducer,
        [consignesApi.reducerPath]: consignesApi.reducer,
        [modesOperatoiresApi.reducerPath]: modesOperatoiresApi.reducer,
        [actesApi.reducerPath]: actesApi.reducer,
        [conteneurConsignesApi.reducerPath]: conteneurConsignesApi.reducer,
        [formActesApi.reducerPath]: formActesApi.reducer,
        [exportsApi.reducerPath]: exportsApi.reducer,
        [interventionDetailApi.reducerPath]: interventionDetailApi.reducer,
        [pilotageApi.reducerPath]: pilotageApi.reducer,
        [simulationsApi.reducerPath]: simulationsApi.reducer,
        conteneurMap: conteneurMapReducer,
    }),
    applyMiddleware(
        ...middlewares
    )
);

setupListeners(store.dispatch);

export default store;
